import { render, staticRenderFns } from "./ViewHeaderHelp.vue?vue&type=template&id=c28c25e8&"
import script from "./ViewHeaderHelp.vue?vue&type=script&lang=js&"
export * from "./ViewHeaderHelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports